import styled from "styled-components";

export const PaginationCustomStyled = styled.div`
  /*===============================================
 Container 
===============================================*/

  /*===============================================
Theme 
===============================================*/
  .theme_standard_pagination {
    .pagination {
      display: flex;
      width: 100%;
      list-style: none;
      justify-content: flex-end;
      align-items: center;
      margin: 0;
      padding: 0;
      .previous {
        display: flex;
      }
      .next {
        display: flex;
      }
      li {
        cursor: pointer;
        font-size: ${({ theme }) => theme.FONT.SIZE.S14};
        font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
        color: ${({ theme }) => theme.COLORS.BLACK_2};
        /* ทุกปุ่มเป็นวงกลมขนาดเท่ากัน จะได้มี hover state ที่ขยับ/เปลี่ยนสีได้สวย */
        border-radius: 50%;
        width: 36px;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 2px;
        transition: background 0.2s ease, color 0.2s ease, transform 0.15s ease,
          box-shadow 0.2s ease;
        a {
          padding: 0;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          outline: none;
        }
        &:hover {
          background: ${({ theme }) => theme.COLORS.BLUE_1};
          color: ${({ theme }) => theme.COLORS.BLUE_4};
          transform: translateY(-1px);
          &.active {
            background: ${({ theme }) => theme.COLORS.BLUE_3};
            color: ${({ theme }) => theme.COLORS.WHITE_1};
            box-shadow: 0 0.25rem 0.75rem rgb(33 111 237 / 35%);
          }
        }
        &:active {
          transform: translateY(0) scale(0.95);
        }
        &.break-me:hover {
          background: transparent;
          transform: none;
        }
      }

      .active {
        background: ${({ theme }) => theme.COLORS.BLUE_4};
        color: ${({ theme }) => theme.COLORS.WHITE_1};
        font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
      }
    }
    /* ลูกศรก่อนหน้า/ถัดไปที่กดไม่ได้ (อยู่หน้าแรก/หน้าสุดท้าย) ซ่อนทั้งปุ่ม ไม่ให้มี hover */
    .pagination li.disabled {
      display: none;
    }
  }
`;
